module.exports = __webpack_public_path__ + "images/791e3438200c2a6e056d83fb7296e4cf.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/gift-categories/wine-lover.jpg
// module id = 1096
// module chunks = 0